import {BrowserRouter, Routes, Route, Outlet} from 'react-router-dom';
import {lazy, StrictMode, Suspense, useEffect, useState} from 'react';

import Loading from './Loading';

const Videos = lazy(() => import('./Videos'));
const Clips = lazy(() => import('./Clips'));
const Player = lazy(() => import('./Player'));
const Login = lazy(() => import('./Login'));
const SelectWatchparty = lazy(() => import('./SelectWatchparty'));

function LoggedIn() {
	const [status, setStatus] = useState(null);
	useEffect(() => {
		const username = localStorage.getItem('username') || '';
		const password = localStorage.getItem('password') || '';

		if (username === '') {
			setStatus(false);
			return;
		}

		fetch(`https://streams.lieuwe.xyz/api/user/${username}?password=${password}`)
			.then(res => setStatus(res.status === 200));
	}, []);

	if (status == null) {
		return <Loading />;
	} else if (status === false) {
		// check if login is required, if so, redirect

		sessionStorage.setItem('redirect', window.location.href);
		window.location.href = '/login';
	}

	return <Outlet />;
}

export default function App() {
	return <StrictMode>
		<Suspense fallback={<Loading />}>
			<BrowserRouter>
				<Routes>
					<Route path="/clip/:id" element={<Player isClip={true} />} />
					<Route path="/login" element={<Login />} />

					<Route element={<LoggedIn />}>
						<Route path="/video/:id" element={<Player isClip={false} />} />
						<Route path="/watchparty" element={<SelectWatchparty />} />
						<Route path="/clips" element={<Clips />} />
						<Route path="/" element={<Videos />} />
					</Route>
				</Routes>
			</BrowserRouter>
		</Suspense>
	</StrictMode>;
}
